// extracted by mini-css-extract-plugin
module.exports = {"navbarCenter":"navbarLayout_navbarCenter__64JqU","subNavbarCenter":"navbarLayout_subNavbarCenter__2N7xd"};